import React, { useEffect, useState } from "react";
import TotalEmails from "../../../assets/images/total-email.svg";
import TodayEmails from "../../../assets/images/today-email.svg";
import { useNavigate, useLocation } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { FiRefreshCw } from "react-icons/fi";
import { BsGrid3X3GapFill, BsFillEnvelopeFill,  } from "react-icons/bs";
import { IoMap, IoCloseCircle, IoFilterSharp } from "react-icons/io5";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";

const apiUrl = process.env.REACT_APP_API_URL;

function Dashboard() {
  const navigate = useNavigate();
  const location = useLocation();
  const [userName, setUserName] = useState("");
  const [recentEmails, setRecentEmails] = useState([]);
  const [totalEmails, setTotalEmails] = useState(0);
  const [totalEmailsToday, setTotalEmailsToday] = useState(0);
  const [loading, setLoading] = useState(true);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [tempFromDate, setTempFromDate] = useState("");
  const [tempToDate, setTempToDate] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (!token) {
      navigate("/");
      return;
    }
    const user = JSON.parse(localStorage.getItem("user"));
    if (user && user.name) {
      setUserName(user.name);
    }
  }, []);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const urlFromDate = searchParams.get("fromDate");
    const urlToDate = searchParams.get("toDate");

    if (urlFromDate) {
      setFromDate(urlFromDate);
      setTempFromDate(urlFromDate);
    }
    if (urlToDate) {
      setToDate(urlToDate);
      setTempToDate(urlToDate);
    }
  }, [location.search]);

  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const updateURLParams = (newFromDate, newToDate) => {
    const searchParams = new URLSearchParams(location.search);

    if (newFromDate) {
      searchParams.set("fromDate", newFromDate);
    } else {
      searchParams.delete("fromDate");
    }

    if (newToDate) {
      searchParams.set("toDate", newToDate);
    } else {
      searchParams.delete("toDate");
    }

    navigate(`${location.pathname}?${searchParams.toString()}`);
  };

  const handlePresetSelect = (preset) => {
    let newFromDate, newToDate;

    switch (preset) {
      case "this-week": {
        const curr = new Date();
        const first =
          curr.getDate() - curr.getDay() + (curr.getDay() === 0 ? -6 : 1);
        newFromDate = new Date(curr.setDate(first));
        newToDate = new Date(curr);
        newToDate.setDate(first + 6);
        break;
      }
      case "last-week": {
        const curr = new Date();

        // Calculate last week's Monday
        const lastMonday = new Date(curr);
        lastMonday.setDate(curr.getDate() - (curr.getDay() || 7) - 6);
        newFromDate = lastMonday;

        // Get Sunday by adding 6 days to Monday
        newToDate = new Date(lastMonday);
        newToDate.setDate(lastMonday.getDate() + 6);
        break;
      }
      case "this-month": {
        const curr = new Date();
        newFromDate = new Date(curr.getFullYear(), curr.getMonth(), 1);
        newToDate = new Date(curr.getFullYear(), curr.getMonth() + 1, 0);
        break;
      }
      case "last-month": {
        const curr = new Date();
        newFromDate = new Date(curr.getFullYear(), curr.getMonth() - 1, 1);
        newToDate = new Date(curr.getFullYear(), curr.getMonth(), 0);
        break;
      }
      default:
        return;
    }

    const formattedFromDate = formatDate(newFromDate);
    const formattedToDate = formatDate(newToDate);

    setFromDate(formattedFromDate);
    setToDate(formattedToDate);
    setTempFromDate(formattedFromDate);
    setTempToDate(formattedToDate);
    updateURLParams(formattedFromDate, formattedToDate);
  };

  const handleTempDateChange = (event, type) => {
    const value = event.target.value;
    if (type === "from") {
      setTempFromDate(value);
    } else {
      setTempToDate(value);
    }
  };

  const handleDateSelection = (type) => {
    if (type === "from") {
      if (toDate && new Date(tempFromDate) > new Date(toDate)) {
        alert(
          "The 'From Date' must be earlier than the 'To Date'. Please correct your selection."
        );
        setTempFromDate(fromDate);
        return;
      }
      setFromDate(tempFromDate);
      updateURLParams(tempFromDate, toDate);
    } else {
      if (fromDate && new Date(fromDate) > new Date(tempToDate)) {
        alert(
          "The 'To Date' must be later than the 'From Date'. Please correct your selection."
        );
        setTempToDate(toDate);
        return;
      }
      setToDate(tempToDate);
      updateURLParams(fromDate, tempToDate);
    }
  };

  const handleClearFilters = () => {
    setFromDate("");
    setToDate("");
    setTempFromDate("");
    setTempToDate("");
    updateURLParams(null, null);
  };

  const handleViewEmail = (e, emailId) => {
    e.preventDefault();
    navigate(`/view-email/${emailId}`);
  };

  useEffect(() => {
    const fetchRecentEmails = async () => {
      setLoading(true);
      const token = localStorage.getItem("accessToken");

      let queryString = `${apiUrl}fetch-dashboard-data`;

      if (fromDate || toDate) {
        queryString += "?";
        if (fromDate) queryString += `fromDate=${fromDate}`;
        if (toDate) queryString += `${fromDate ? "&" : ""}toDate=${toDate}`;
      }

      try {
        const response = await fetch(queryString, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          const data = await response.json();
          setRecentEmails(data.emails);
          setTotalEmails(data.totalEmails);
          setTotalEmailsToday(data.totalEmailsCreatedToday);
        } else {
          console.error("Failed to fetch recent emails");
        }
      } catch (error) {
        console.error("Error fetching emails:", error);
      }

      setLoading(false);
    };

    fetchRecentEmails();
  }, [fromDate, toDate]);

  if (loading) {
    return (
      <div className="text-center mt-5">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="dashboard-title mb-3">
        <h1>Dashboard</h1>
        <div className="dropdown-container">
                <Dropdown>
                    <Dropdown.Toggle variant="light" id="dropdown-basic" className="rounded-circle border-0 bg-transparent">
                    <div className="menu-icon">
                        <BsGrid3X3GapFill />
                    </div>
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="dropdown-menu-custom">
                    <Dropdown.Item href="/dashboard" className="dropdown-item-custom">
                        <BsFillEnvelopeFill className="dropdown-icon" /> Quote/Bind Email
                    </Dropdown.Item>
                    <Dropdown.Item href="/geographical-concentration" className="dropdown-item-custom">
                        <IoMap className="dropdown-icon" /> Geographical Concentration
                    </Dropdown.Item>
                    <Dropdown.Item href="/renewals-dashboard" className="dropdown-item-custom">
                        <FiRefreshCw className="dropdown-icon" /> Renewals
                    </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
                </div>
      </div>
      <div
        className="welcome-banner mb-3"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "1rem",
          backgroundColor: "#1a237e",
          color: "white",
          borderRadius: "4px",
        }}
      >
        <div>Welcome back {userName},</div>
        <div className="dropdown">
          <button
            className="btn btn-secondary dropdown-toggle"
            type="button"
            id="dateFilterDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="bi bi-calendar me-2"></i>Date Filter
          </button>
          <ul
            className="dropdown-menu p-3"
            aria-labelledby="dateFilterDropdown"
          >
            <li>
              <button
                className="dropdown-item"
                onClick={() => handlePresetSelect("this-week")}
              >
                This Week
              </button>
            </li>
            <li>
              <button
                className="dropdown-item"
                onClick={() => handlePresetSelect("last-week")}
              >
                Last Week
              </button>
            </li>
            <li>
              <button
                className="dropdown-item"
                onClick={() => handlePresetSelect("this-month")}
              >
                This Month
              </button>
            </li>
            <li>
              <button
                className="dropdown-item"
                onClick={() => handlePresetSelect("last-month")}
              >
                Last Month
              </button>
            </li>
            <hr className="my-2" />
            <li className="px-2">
              <div className="mb-2">
                <label className="form-label">From Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={tempFromDate}
                  onChange={(e) => handleTempDateChange(e, "from")}
                  onBlur={() => handleDateSelection("from")}
                />
              </div>
              <div className="mb-2">
                <label className="form-label">To Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={tempToDate}
                  onChange={(e) => handleTempDateChange(e, "to")}
                  onBlur={() => handleDateSelection("to")}
                />
              </div>
              <div className="mt-3">
                <button
                  className="btn btn-secondary w-100"
                  onClick={handleClearFilters}
                >
                  Clear Dates
                </button>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div className="row clearfix">
        <div className="col-12 col-lg-6">
          <div className="dash-card">
            <div className="dash-card-header">Recent Emails</div>
            <div className="dash-card-body">
              <div className="table-container">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Emails</th>
                      <th scope="col">Created date</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {recentEmails.map((email, index) => (
                      <tr key={email._id}>
                        <th scope="row">{index + 1}</th>
                        <td>{email.emailName}</td>
                        <td>
                          {new Date(email.createdAt).toLocaleDateString()}
                        </td>
                        <td>
                          <a
                            href=""
                            onClick={(e) => handleViewEmail(e, email._id)}
                          >
                            <i className="bi bi-eye"></i>
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-6">
          <ul className="top-grid">
            <li>
              <div className="image-holder">
                <img
                  src={TotalEmails}
                  className="img-fluid"
                  alt="Total Emails"
                />
              </div>
              <h3>
                {totalEmails}
                <span>Total Emails created</span>
              </h3>
            </li>
            <li>
              <div className="image-holder">
                <img
                  src={TodayEmails}
                  className="img-fluid"
                  alt="Today Emails"
                />
              </div>
              <h3>
                {totalEmailsToday}
                <span>Total Emails created today</span>
              </h3>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}

export default Dashboard;
